export enum FormState {
    signUp = 'Sign Up',
    login = 'Loign',
    createPassword = 'Create Password',
    sharableFile = 'Shareable File'
}